import styled from 'styled-components';

export const ModalContainer = styled.div`
  div[data-id='modal-dialog'] {
    height: auto;

    & > div {
      width: 16.375rem;
      height: auto;
      overflow: visible;
      border-radius: 4px;

      div > div > button {
        padding: 0 0.25rem;
      }

      div > div > button > svg {
        fill: ${({ theme: { colors } }): string => colors.black};
        height: 0.5rem;
        width: 0.5rem;
      }

      div[data-id='modal-header'] {
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
      }

      a[data-id='tooltip-modal-button'] {
        font-size: ${({ theme: { fontSizes } }): string => fontSizes.f1};
        padding: 0.5rem 1rem;
        line-height: 0.834;
      }
    }
  }

  div[data-id='modal-backdrop'] {
    background-color: transparent;
  }
`;

export const TriangleShape = styled.div`
  position: absolute;
  top: -1.25rem;
  right: ${({ theme: { spacing } }) => spacing.md1};
  border: 12px solid transparent;
  border-bottom-color: ${({ theme: { colors } }): string => colors.white};
`;
